<template>
    <div>
        <div class="container">
            <BannerCarousel @error-modal="showErrorModalFunc" @success-modal="showSuccessModalFunc" v-if="this.active_el != 7" />
            <div class="mobile-view-nav">
                <div class="mobile-view lft-side-tabs">
                    <ul class="home-navigation-bar">
                        <li v-for="(sport, n_index) in filteredSports?.commonSports" :key="n_index" class="nav-item">
                            <a class="nav-link" @click="activate(sport.slug); getSportsListData(sport.id)"
                                :class="{ active: active_el == sport.slug }">
                                <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                <span>{{ translatedLangData(sport.slug,sport.name) }}</span>
                            </a>
                        </li>
                        
                        <li class="nav-item" @click.prevent="goToSportsBook()">
                            <router-link to="" class="nav-link" @click="activate(5,'evolution')" :class="{ active: active_el == 5 }">
                                <img src="@/assets/images/tb-sports-book.svg" alt="">
                                <span>{{ translatedLangData('sportsbook', 'Sports Book') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="" class="nav-link" @click="activate(70,'evolution')" :class="{ active: active_el == 70 }">
                                <img src="@/assets/images/tb-evolution-icon.svg" alt="">
                                <span>{{ translatedLangData('evolution', 'Evolution') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="" class="nav-link" @click="activate(7, 'live-casino')" :class="{ active: active_el == 7 }">
                                <img src="@/assets/images/tb-poker-cards.svg" alt="">
                                <span>{{ translatedLangData('live-casino', 'Live Casino') }}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/cricket-fight" class="nav-link" @click="activate(11)" :class="{ active: active_el == 11 }">
                                <img src="@/assets/images/tb-cricket-fight.svg" alt="">
                                <span>{{ translatedLangData('cricket-fight', 'Cricket Fight') }}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/matka" class="nav-link" @click="activate(110)" :class="{ active: active_el == 110 }">
                                <img src="@/assets/images/matka-icon.svg" alt="">
                                <span>{{ translatedLangData('matka', 'Matka') }}</span>
                            </router-link>
                        </li>
                        <li v-for="(sport, n_index) in filteredSports?.extraSports" :key="n_index" class="nav-item">
                            <a class="nav-link" @click="activate(sport.slug); getSportsListData(sport.id)"
                                :class="{ active: active_el == sport.slug }">
                                <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                <span>{{ translatedLangData(sport.slug,sport.name) }}</span>
                            </a>
                        </li>
                        <li v-for="(sport, c_index) in custom_sports" :key="c_index" class="nav-item">
                            <a class="nav-link" @click="activate(sport.slug); getSportsListData(sport.id)"
                                :class="{ active: active_el == sport.slug }">
                                <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                                <span>{{ translatedLangData(sport.slug,sport.name) }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="right-fixed-search-btn">
                    <a href="#searchModal" data-bs-toggle="modal" class="a-search">
                        <img src="@/assets/images/search.png" alt="">
                    </a>
                </div>
            </div>

            <div v-if="active_el != 7 && active_el != 70" class="tab-content fixed-game-header">
                <div heading="Cricket" class="active tab-pane">
                    <div class="row">
                        <div class="col-md-12 mobile-width scrollHeight">
                            <div class="ng-star-inserted">
                                <SportItem v-if="matches_list.length!=0" :sportsData="matches_list" @error-modal="showErrorModalFunc" @success-modal="showSuccessModalFunc" />
                                <table v-else class="table table-hover dashboard-custom-table"
                                    style="border-bottom: 1px solid #c8ced3;">
                                    <tbod>
                                        <tr class="btm-light-table-row">
                                            <td colspan="10" class="text-center">
                                                {{ translatedLangData('no-events-displayed', 'There are no events to be displayed') }}.
                                            </td>
                                        </tr>
                                    </tbod>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SportWiseCasino v-if="sectionsList && sectionsList.length!=0" :currentSectionType="currentSectionType" :checkRerender="checkRerender" :searchCasinoHide = "searchCasinoHide" @change-render="changeRender()"
                @error-modal="showErrorModalFunc" @success-modal="showSuccessModalFunc" :key="currentSectionType"></SportWiseCasino>

            <div class="app-downlode">
                <div class="mobile-app-footer-main">
                    <div class="support-mail">
                        <ul>
                            <li class="nav-item">
                                <a href="#privacyPolicyModal" data-bs-toggle="modal" class="support-mail-divider">
                                    {{ translatedLangData('privacy-policy', 'Privacy Policy') }}
                                </a>
                            </li>
                            <li>
                                <a href="#kycModal" class="support-mail-divider" data-bs-toggle="modal">
                                    {{ translatedLangData('kyc', 'KYC') }}
                                </a>
                            </li>
                            <li>
                                <a href="#ruleRegulationModal" class="support-mail-divider" data-bs-toggle="modal">
                                    {{ translatedLangData('terms-and-conditions', 'Terms And Conditions') }}
                                </a>
                            </li>
                            <li>
                                <a href="#ruleRegulationModal" data-bs-toggle="modal" class="support-mail-divider">
                                    {{ translatedLangData('rules-and-regulations', 'Rules and Regulations') }}
                                </a>
                            </li>
                            <li>
                                <a href="#ruleRegulationModal" data-bs-toggle="modal">
                                    {{ translatedLangData('responsible-gambling', 'Responsible Gambling') }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="download-apk-btn">
                        <button type="button" data-bs-toggle="modal" data-bs-target="#install-apk-model">
                            <img src="@/assets/images/btn-appdl.webp" alt="">
                        </button>
                    </div>

                    <div class="mobile-app-footer">
                        <ul class="social-icon-wrapper" v-if="siteSettings && siteSettings?.social_link">
                            <li v-if="siteSettings.social_link.telegram_link">
                                <a :href="siteSettings.social_link.telegram_link" target="_blank">
                                    <img src="@/assets/images/telegram-share.svg" class="telegram-share">
                                </a>
                            </li>
                            <li v-if="siteSettings.social_link.whatsappno1">
                                <a :href="'//wa.me/' + siteSettings.social_link.whatsappno1" target="_blank">
                                    <img src="@/assets/images/whatsapp-share.svg" class="whatsapp-share">
                                </a>
                            </li>
                            <li v-if="siteSettings.social_link.instagram_link">
                                <a :href="siteSettings.social_link.instagram_link" target="_blank">
                                    <img src="@/assets/images/instagram-share.svg" class="instagram-share">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-fixed-icn" v-if="siteSettings && siteSettings?.business_type == 2" data-bs-toggle="modal" data-bs-target="#whatsup-depositModal">
            <a href="javascript:void(0);" @click="getParentWhatsappNumber">
                <img src="@/assets/images/whatsapp-share.svg" class="whatsapp-share">
            </a>
        </div>
        <div style="visibility:hidden" ref="login_modal" data-bs-toggle="modal" data-bs-target="#staticBackdrop-one"></div>

        <!-- Whatsapp modal -->
        <div class="">
            <div class="modal fade" id="whatsup-depositModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="thm-heading">
                                <h3><strong>{{ translatedLangData('customer-support', 'Customer Support') }}</strong></h3>
                            </div>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            </button>
                        </div>
                        <div class="modal-body whatsup-modal-information">
                            <div class="whatsaap-support-btn-list">
                                <template v-if="whatsappNumbers && whatsappNumbers.length > 0">
                                    <div class="support-call-now" v-for="(data, index) in whatsappNumbers" :key="index">
                                        <a :href="'https://wa.me/' + data.whatsapp_number" target="_blank">
                                            <div class="support-whatsapp-icon">
                                                <img src="@/assets/images/whatsapp-icon-new.svg" alt="whatsapp">
                                            </div>
                                            <span class="btn thm-btn">{{ data.category_name }}</span>
                                        </a>
                                    </div>
                                </template>
                                <template v-else-if="siteSettings && (siteSettings.social_link?.whatsappno1 || siteSettings.social_link?.whatsappno2)">
                                    <div class="support-call-now" v-for="(number, index) in [siteSettings.social_link?.whatsappno1, siteSettings.social_link?.whatsappno2]" :key="index">
                                        <a v-if="number" :key="number" :href="'https://wa.me/' + number" target="_blank">
                                            <div class="support-whatsapp-icon">
                                                <img src="@/assets/images/whatsapp-icon-new.svg" alt="whatsapp">
                                            </div>
                                            <span class="btn thm-btn">{{ number }}</span>
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       <!-- Download apk modal -->
       <div class="install-apk-model">
        <div class="modal fade " id="install-apk-model" tabindex="-1" aria-labelledby="exampleModalLabel" data-bs-backdrop="static" aria-modal="true" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="thm-heading">
                            <h3>{{ translatedLangData('how-to-install-apk', 'How To Install APK') }}</h3>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="install-app-content">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" 
                                    role="tab" aria-controls="home" aria-selected="false" tabindex="-1">
                                    {{ translatedLangData('android', 'Android') }}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" 
                                    type="button" role="tab" aria-controls="profile" aria-selected="true">
                                    {{ translatedLangData('ios', 'iOS') }}
                                </button>
                            </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade active show" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="how-install-content">
                                <img src="@/assets/images/android-apk-img.jpg" alt="">
                                </div>
                            </div>
                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div class="how-install-content">
                                <img src="@/assets/images/ios-apk-img.jpg" alt="">
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn close-btn" data-bs-dismiss="modal">
                            {{ translatedLangData('close', 'Close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <SearchModal></SearchModal>
        <FooterInfoCom></FooterInfoCom>
        <AgeConfLoginModal></AgeConfLoginModal>
    </div>
</template>

<script>
import BannerCarousel from '@/shared/components/banner/BannerCarousel.vue';
import api from './services/api';
import * as apiName from './services/urls';
import click_api from './services/click_api';
import Race from '@/shared/components/race/Race.vue';
import { mapGetters } from 'vuex';
import { setGameItem } from "@/shared/constants/shared-data";
import IFrameModal from "@/modules/games/components/IFrameModal.vue";
import SportWiseCasino from "../modules/games/components/SportwiseCasino.vue";
import SportItem from '@/modules/sports/components/SportItem.vue';
import SearchModal from '@/shared/components/search/SearchModal.vue' 
import FooterInfoCom from '@/modules/account/components/HomeFooterInfo.vue';
import * as varConstants from '@/shared/constants/var-constants';
import AgeConfLoginModal from '@/shared/components/modal/AgeConfirmationLoginModal.vue';
import { Modal } from "bootstrap";

export default {
    name: 'Home',
    inject:['translatedLangData'],
    components: {
        BannerCarousel,
        Race,
        IFrameModal,
        SportWiseCasino,
        SportItem,
        SearchModal,
        FooterInfoCom,
        AgeConfLoginModal
    },
    data() {
        return {
            gamesData: null,
            sectionsList: null,
            recommendedGameList: null,
            openIframeModal: false,
            sectionWiseGamesList: [
                {
                    slugName: 'royal-live-games',
                    gamesList: null,
                },
                {
                    slugName: 'top-games',
                    gamesList: null,
                },
                {
                    slugName: 'aviator',
                    gamesList: null,
                },

            ],
            loading: false,
            inplayMatches: [],
            recommendedMatches: [],
            custom_sports: this.$store.getters.sports_list?.custom ?? [],
            non_custom_sports: this.$store.getters.sports_list?.non_custom ?? [],
            matchCounts: null,
            sectionImgs: [],
            active_el: 0,
            matchesArray: [],
            eventManage: null,
            matches_list: [],
            marketOdds: {},
            favouriteGamesList: localStorage.getItem(varConstants.FAV_GAMES_LIST) ? JSON.parse(localStorage.getItem(varConstants.FAV_GAMES_LIST)) : [],
            favouriteSportsList: localStorage.getItem(varConstants.FAV_SPORTS_LIST) ? JSON.parse(localStorage.getItem(varConstants.FAV_SPORTS_LIST)) : [],
            currentSectionType: 'home',
            checkRerender: true,
            whatsappNumbers:[],
            searchCasinoHide:false,
        }

    },
    computed: {
        ...mapGetters([
            'siteSettings',
            'domainName'
        ]),
        intCasino() {
            return this.sectionsList?.find(item => item.slug == 'int-casino');
        },
        liveCasino() {
            return this.sectionsList?.find(item => item.slug == 'live-casino');

        },
        popularGames() {
            return this.sectionsList?.find(item => item.slug == 'popular-games');
        },
        filteredSports() {
            return {
                commonSports: this.non_custom_sports.filter(sport => [1, 2, 4].includes(sport.id)),
                extraSports: this.non_custom_sports.filter(sport => ![1, 2, 4].includes(sport.id))
            };
        },
        sortedNonCustomSports() {
            const order = ['cricket', 'football', 'tennis'];
            return this.non_custom_sports.sort((a, b) => {
                const aIndex = order.indexOf(a.name.toLowerCase());
                const bIndex = order.indexOf(b.name.toLowerCase());

                if (aIndex !== -1 || bIndex !== -1) {
                return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
                }
                return a.rank - b.rank;
            });
        },
    },
    mounted() {
        this.eventManage = this.$store?.getters?.eventManage;
        this.getCasinoGamesServiceCall();
        this.getInplayMatchCounts();
        if (this.non_custom_sports == null || this.non_custom_sports.length == 0) {
            this.get_sportsList()
        }
        else {
            this.getSportsListData(this.filteredSports?.commonSports[0]?.id);
            this.activate(this.filteredSports?.commonSports[0].slug)
        }
    },
    methods: {
        getInplayMatchCounts() {
            click_api.get(apiName.INPLAY_MATCHES_COUNT).then(response => {
                if (response && response.status == 200) {
                    let respData = response.data.data;
                    let sportCount = {
                        cricket: 0,

                        soccer: 0,
                        tennis: 0,
                    };

                    for (const key in respData) {
                        if (key == 4) {
                            sportCount.cricket = respData[key].inplay
                        } else if (key == 1) {
                            sportCount.soccer = respData[key].inplay
                        } else if (key == 2) {
                            sportCount.tennis = respData[key].inplay
                        } else {
                            const sportName = respData[key].sport_name;
                            sportCount[sportName] = respData[key].inplay;
                        }
                    }
                    this.matchCounts = sportCount;
                }
            }).catch(error => {
                if (error) {
                }
            });
        },

        get_sportsList() {
            this.loading = true;
            click_api.get(apiName.GET_SPORTS).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        var all_sports = response.data.data
                        this.non_custom_sports = []
                        for (var i = 0; i < all_sports.length; i++) {
                            if (all_sports[i].is_custom == 0) {
                                this.non_custom_sports.push(all_sports[i])
                            } else {
                                this.custom_sports.push(all_sports[i])
                            }
                        }
                        this.non_custom_sports.sort((a, b) => {
                            return a.rank - b.rank;
                        });

                        var sport_list = {}
                        sport_list['custom'] = this.custom_sports
                        sport_list['non_custom'] = this.sortedNonCustomSports
                        this.$store.dispatch('setSportsList',sport_list)
                        this.getSportsListData(this.non_custom_sports[0].id)
                        this.activate(this.non_custom_sports[0].slug)
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    // this.showErrorModalFunc(error.data.message);
                }
            });
        },

        getSportsListData(sport_id) {
            this.$store.dispatch('setGlobalLoader', true);
            click_api.get(apiName.MATCHES_BY_SPORT_ID + sport_id).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        this.matches_list = response.data.data;
                        for (let match of this.matches_list) {
                            this.marketOdds[match.market_id] = match.runners ?? [];
                        }
                        this.matchesArray = response.data.data;
                        if (this.checkIsLogin()) {

                            let lockedMatchIds = this.eventManage?.find(item => item.type == 'match');
                            let lockedLeagueIds = this.eventManage?.find(item => item.type == 'league');

                            lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                            lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []

                            for (var i = 0; i < this.matches_list.length; i++) {
                                if (this.checkForLockedMatches(this.matches_list[i].matchId, this.matches_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                                    if (this.favouriteSportsList?.includes(parseInt(this.matches_list[i].event_id))) {
                                        this.matches_list[i]['favourite'] = true
                                    } else {
                                        this.matches_list[i]['favourite'] = false
                                    }
                                } else {
                                    this.matches_list.splice(i, 1)
                                }
                            }
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.showErrorModalFunc(error);
                }
            });
        },

        checkForLockedMatches(matchId, league_id, lockedMatchIds, lockedLeagueIds) {
            return this.checkIsLogin() && (lockedMatchIds.length || lockedLeagueIds.length) ? !lockedMatchIds?.includes(matchId.toString()) && !lockedLeagueIds?.includes(league_id.toString()) : true
        },

        activate(el, sectionType) {
            this.checkRerender = true
            this.active_el = el;
            if (this.active_el == 7) {
                this.searchCasinoHide = true;
            }
            if (sectionType == 'evolution') {
                this.currentSectionType = sectionType;
            } else if (sectionType == 'live-casino') {
                this.currentSectionType = sectionType;
            } else {
                this.currentSectionType = 'home';
            }
        },
        checkIsLogin() {
            return this.$store.getters.isAuthenticated;
        },
        clickOnLoginModal() {
            this.$refs.login_modal.click();
        },
        getCasinoGamesServiceCall() {

            let casinoData = this?.$store?.getters?.gamesData;
				this.gamesData = casinoData;
				this.sectionsList = casinoData?.sections;
				this.setSectionList();
        },
        setSectionList() {
            try {
                for (let i = 0; i < this.sectionsList.length; i++) {
                    let gamesList = [];
                    if (this.sectionsList[i].menus) {
                        for (let j = 0; j < this.sectionsList[i].menus.length; j++) {
                            gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
                        }
                    } else {
                        gamesList = this.sectionsList[i].games;
                    }

                    let gameListNew = [];

                    gameListNew = gamesList;
                    const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
                    gameListNew.sort((a, b) => naturalCollator.compare(a.porder, b.porder));
                    switch (this.sectionsList[i].slug) {
                        case 'royal-live-games':
                            this.sectionWiseGamesList[0].gamesList = gameListNew;
                            break;
                        case 'top-games':
                            this.sectionWiseGamesList[1].gamesList = gameListNew;
                            break;
                        case 'aviator':
                            this.sectionWiseGamesList[2].gamesList = gameListNew;
                            break;
                    }
                }

            } catch (error) {
            }
        },
        clickOnGamestButton(item) {
            if (this.checkIsLogin()) {
                this.openGamesPopup(item);
            } else {
                this.$refs.login_modal.click();
            }
        },
        openGamesPopup(gameItem) {
            setGameItem(gameItem);
            switch (this.userData().currency) {
                case 1:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    } else if (gameItem.only_hkd == 0) {
                        this.openIframeModal = true;
                        this.$refs.iframe_pop_modal_home.click();
                    }
                    break;
                case 2:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    } else if (gameItem.only_hkd == 0) {
                        this.$refs.games_pop_2_modal.click();
                    }
                    break;
                case 3 || 4:
                    this.openIframeModal = true;
                    this.$refs.iframe_pop_modal_home.click();
                    break;
            }
        },
        goToSportsBook() {
            if (this.checkIsLogin()) {
                this.$router.push({ name: 'sports-book' })
            } else {
                const modal = new Modal(document.getElementById('ageconfirmationModal'));
                modal.show();
            }
        },
        closeModalIframe() {
            this.openIframeModal = false;
        },
        userData() {
            return this.$store.getters.stateUser;
        },
        showErrorModalFunc(message) {
            this.$emit('error-modal', message)
        },

        showSuccessModalFunc(message) {
            this.$emit('success-modal', message)
        },
        changeRender(){
            this.checkRerender = false    
        },
        async getParentWhatsappNumber() {
            if (this.checkIsLogin()) {
                this.loading = true;
                try {
                    const cpiExists = this.$store.getters.stateUser?.cpi;
                    const supportNumbers = this.siteSettings.support_numbers || [];
                    if (!cpiExists) {
                        return;
                    }
                    const now = new Date();
                    const totalMinutes = now.getHours() * 60 + now.getMinutes();

                    this.whatsappNumbers = supportNumbers
                        .filter(entry => entry.id === cpiExists)
                        .flatMap(entry => entry.categories.map(category => {
                            const whatsappNumbers = category.value.split(',');
                            const selectedNumberIndex = totalMinutes % whatsappNumbers.length;
                            return {
                                category_name: category.name,
                                whatsapp_number: whatsappNumbers[selectedNumberIndex]
                            };
                        }));
                        console.log("whatsa",this.whatsappNumbers);
                        
                    this.loading = false;
                } catch (error) {
                    this.loading = false;
                    this.showErrorModalFunc(error[0]);
                }
            }
        },
        getSportImage(sportId) {
            const imageMap = {
            4: require("@/assets/images/tb-cricket-player-with-bat.svg"),
            1: require("@/assets/images/tb-soccer.svg"),
            2: require("@/assets/images/tb-tennis-player.svg"),
            1477: require("@/assets/images/tb-rugby-league.svg"),
            6: require("@/assets/images/tb-boxing.svg"),
            5: require("@/assets/images/tb-rugby-union.svg"),
            3: require("@/assets/images/tb-golf.svg"),
            27454571: require("@/assets/images/tb-esports.svg"),
            2152880: require("@/assets/images/tb-gaelic-football.svg"),
            998917: require("@/assets/images/tb-volleyball.svg"),
            7524: require("@/assets/images/tb-ice-hockey.svg"),
            7522: require("@/assets/images/tb-basketball.svg"),
            7511: require("@/assets/images/tb-baseball.svg"),
            6423: require("@/assets/images/tb-american-football.svg"),
            6422: require("@/assets/images/tb-snooker.svg"),
            11: require("@/assets/images/tb-cycling.svg"),
            8: require("@/assets/images/tb-motor-sport.svg"),
            2378961: require("@/assets/images/tb-politics.svg"),
            468328: require("@/assets/images/tb-handball.svg"),
            61420: require("@/assets/images/tb-australian-rules.svg"),
            3503: require("@/assets/images/tb-darts.svg"),
            10: require("@/assets/images/tb-special-bets.svg"),
            26420387: require("@/assets/images/tb-mixed-martial-arts.svg"),
            4339: require("@/assets/images/tb-greyhound-racing.svg"),
            7: require("@/assets/images/tb-horse-racing.svg"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.svg"); // Fallback image
        },
    }
}
</script>

<style scoped>
.scroll-manu {
    padding-bottom: 20px !important;
}
</style>